import chroma from 'chroma-js';

const PRIMARY = '#348ded';

const CHART_SECONDARY = PRIMARY;
const CHART_PRIMARY = chroma(CHART_SECONDARY).brighten(1).css();

export const baseColors = {
  PRIMARY,
  SECONDARY: '#BFD8FF',

  CHART_PRIMARY,
  CHART_SECONDARY,
};
